import { get } from '../utils/networking';

/**
 * Feature keys that can be enabled for a tenant
 */
export type TenantFeatureKey =
  | 'PSYCHOLOGICAL_SAFETY'
  | 'CUSTOM_SURVEYS'
  | 'WORK_ENVIRONMENT'
  | 'ACTION_PLANS'
  | 'HR_ANALYTICS'
  | 'INTEGRATIONS'
  | 'CONTENT_SYSTEM'
  | 'SSO'
  | 'SAFETY_ROUNDS';

/**
 * Fetch all enabled features for the authenticated user's tenant
 * Returns an array of feature keys (e.g., ['PSYCHOLOGICAL_SAFETY', 'CUSTOM_SURVEYS'])
 */
export async function fetchTenantFeatures(): Promise<TenantFeatureKey[]> {
  return get<TenantFeatureKey[]>('/api/tenant/features');
}
